import {type IconProp} from '@fortawesome/fontawesome-svg-core'
import {
  faArrowDown as faArrowDownLight,
  faArrowDownRight as faArrowDownRightLight,
  faArrowDownToLine as faArrowDownToLineLight,
  faArrowDownWideShort as faArrowDownWideShortLight,
  faArrowLeft as faArrowLeftLight,
  faArrowRightArrowLeft as faArrowRightArrowLeftLight,
  faArrowRight as faArrowRightLight,
  faArrowUp as faArrowUpLight,
  faArrowUpRight as faArrowUpRightLight,
  faArrowUpShortWide as faArrowUpShortWideLight,
  faBank as faBankLight,
  faBars as faBarsLight,
  faBell as faBellLight,
  faBrowsers as faBrowsersLight,
  faBullseyeArrow as faBullseyeArrowLight,
  faChartWaterfall as faChartWaterfallLight,
  faCheckCircle as faCheckCircleLight,
  faCheck as faCheckLight,
  faChevronDown as faChevronDownLight,
  faChevronLeft as faChevronLeftLight,
  faChevronRight as faChevronRightLight,
  faChevronUp as faChevronUpLight,
  faCircleExclamation as faCircleExclamationLight,
  faCircleInfo as faCircleInfoLight,
  faCircle as faCircleLight,
  faCircleNodes as faCircleNodesLight,
  faCircleXmark as faCircleXmarkLight,
  faCopy as faCopyLight,
  faCreditCard as faCreditCardLight,
  faEdit as faEditLight,
  faFileInvoiceDollar as faFileInvoiceDollarLight,
  faFileUser as faFileUserLight,
  faFileZipper as faFileZipperLight,
  faGear as faGearLight,
  faGears as faGearsLight,
  faGlobe as faGlobeLight,
  faLayerGroup as faLayerGroupLight,
  faLink as faLinkLight,
  faMagnifyingGlassDollar as faMagnifyingGlassDollarLight,
  faMagnifyingGlass as faMagnifyingGlassLight,
  faMinus as faMinusLight,
  faMoneyBill as faMoneyBillLight,
  faPaste as faPasteLight,
  faPlus as faPlusLight,
  faReceipt as faReceiptLight,
  faScrewdriverWrench as faScrewdriverWrenchLight,
  faSparkles as faSparklesLight,
  faSpinnerThird as faSpinnerThirdLight,
  faTable as faTableLight,
  faUserCheck as faUserCheckLight,
  faUserGroupSimple as faUserGroupSimpleLight,
  faUser as faUserLight,
  faVolume as faVolumeLight,
  faVolumeSlash as faVolumeSlashLight,
  faXmark as faXmarkLight,
} from '@fortawesome/pro-light-svg-icons'
import {
  faArrowDown as faArrowDownRegular,
  faArrowDownRight as faArrowDownRightRegular,
  faArrowDownToLine as faArrowDownToLineRegular,
  faArrowDownWideShort as faArrowDownWideShortRegular,
  faArrowLeft as faArrowLeftRegular,
  faArrowRightArrowLeft as faArrowRightArrowLeftRegular,
  faArrowRight as faArrowRightRegular,
  faArrowUp as faArrowUpRegular,
  faArrowUpRight as faArrowUpRightRegular,
  faArrowUpShortWide as faArrowUpShortWideRegular,
  faBank as faBankRegular,
  faBars as faBarsRegular,
  faBell as faBellRegular,
  faBrowsers as faBrowsersRegular,
  faBullseyeArrow as faBullseyeArrowRegular,
  faChartWaterfall as faChartWaterfallRegular,
  faCheckCircle as faCheckCircleRegular,
  faCheck as faCheckRegular,
  faChevronDown as faChevronDownRegular,
  faChevronLeft as faChevronLeftRegular,
  faChevronRight as faChevronRightRegular,
  faChevronUp as faChevronUpRegular,
  faCircleExclamation as faCircleExclamationRegular,
  faCircleInfo as faCircleInfoRegular,
  faCircleNodes as faCircleNodesRegular,
  faCircle as faCircleRegular,
  faCircleXmark as faCircleXmarkRegular,
  faCopy as faCopyRegular,
  faCreditCard as faCreditCardRegular,
  faEdit as faEditRegular,
  faFileInvoiceDollar as faFileInvoiceDollarRegular,
  faFileUser as faFileUserRegular,
  faFileZipper as faFileZipperRegular,
  faGear as faGearRegular,
  faGears as faGearsRegular,
  faGlobe as faGlobeRegular,
  faLayerGroup as faLayerGroupRegular,
  faLink as faLinkRegular,
  faMagnifyingGlassDollar as faMagnifyingGlassDollarRegular,
  faMagnifyingGlass as faMagnifyingGlassRegular,
  faMinus as faMinusRegular,
  faMoneyBill as faMoneyBillRegular,
  faPaste as faPasteRegular,
  faPlus as faPlusRegular,
  faReceipt as faReceiptRegular,
  faScrewdriverWrench as faScrewdriverWrenchRegular,
  faSparkles as faSparklesRegular,
  faSpinnerThird as faSpinnerThirdRegular,
  faTable as faTableRegular,
  faUserCheck as faUserCheckRegular,
  faUserGroupSimple as faUserGroupSimpleRegular,
  faUser as faUserRegular,
  faVolume as faVolumeRegular,
  faVolumeSlash as faVolumeSlashRegular,
  faXmark as faXmarkRegular,
} from '@fortawesome/pro-regular-svg-icons'
import {
  faPause as faPauseHeavy,
  faPlay as faPlayHeavy,
} from '@fortawesome/pro-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {tv} from 'tailwind-variants'
import {cn, unreachableCase} from '~/design-system/utils'
import Placeholder from './icons/placeholder.svg'

type HgIconSize = 'small' | 'regular' | 'large'

export const HgCustomIcons = ['placeholder'] as const

export const HgFaIcons = [
  'arrow-down',
  'arrow-left',
  'arrow-right',
  'arrow-up',
  'arrow-down-right-angle',
  'arrow-up-right-angle',
  'audio-off',
  'audio-on',
  'chevron-down',
  'chevron-left',
  'chevron-right',
  'chevron-up',
  'checkmark',
  'copy',
  'download',
  'edit',
  'error',
  'info',
  'link',
  'loading',
  'menu',
  'minus',
  'paste',
  'pause',
  'play',
  'plus',
  'search',
  'settings',
  'success',
  'user',
  'xmark',
  'xmark-circle',
  'arrow-right-arrow-left',
  'bank',
  'credit-card',
  'chart-waterfall',
  'gears',
  'money-bill',
  'sparkles',
  'circle-nodes',
  'user-check',
  'invoice',
  'globe',
  'magnifying-glass-dollar',
  'stack',
  'arrow-up-short-wide',
  'arrow-down-wide-short',
  'user-group-simple',
  'screwdriver-wrench',
  'receipt',
  'bell',
  'bullseye-arrow',
  'browsers',
  'file-user',
  'table',
  'file-zipper',
] as const

type HgFaIconType = (typeof HgFaIcons)[number]

type HgFaIconProps = {
  className?: string
  iconType: HgFaIconType
  size: HgIconSize
}

type HgCustomIconType = (typeof HgCustomIcons)[number]

export type HgIconType = HgFaIconType | HgCustomIconType

type HgIconProps = {
  className?: string
  iconType: HgIconType
  size: HgIconSize
}

const SANCTIONED_FA_ICON_MAP: Record<
  // 'loading' is a special case of 2 FA icons being combined rather than the 1:1 mapping of the other FA icons
  Exclude<HgFaIconType, 'loading'>,
  Record<HgIconSize, IconProp>
> = {
  // "UI" icons
  'arrow-down': {
    small: faArrowDownRegular,
    regular: faArrowDownRegular,
    large: faArrowDownLight,
  },
  'arrow-left': {
    small: faArrowLeftRegular,
    regular: faArrowLeftRegular,
    large: faArrowLeftLight,
  },
  'arrow-right': {
    small: faArrowRightRegular,
    regular: faArrowRightRegular,
    large: faArrowRightLight,
  },
  'arrow-up': {
    small: faArrowUpRegular,
    regular: faArrowUpRegular,
    large: faArrowUpLight,
  },
  'arrow-down-right-angle': {
    small: faArrowDownRightRegular,
    regular: faArrowDownRightRegular,
    large: faArrowDownRightLight,
  },
  'arrow-up-right-angle': {
    small: faArrowUpRightRegular,
    regular: faArrowUpRightRegular,
    large: faArrowUpRightLight,
  },
  'audio-off': {
    small: faVolumeSlashRegular,
    regular: faVolumeSlashRegular,
    large: faVolumeSlashLight,
  },
  'audio-on': {
    small: faVolumeRegular,
    regular: faVolumeRegular,
    large: faVolumeLight,
  },
  'chevron-down': {
    small: faChevronDownRegular,
    regular: faChevronDownRegular,
    large: faChevronDownLight,
  },
  'chevron-left': {
    small: faChevronLeftRegular,
    regular: faChevronLeftRegular,
    large: faChevronLeftLight,
  },
  'chevron-right': {
    small: faChevronRightRegular,
    regular: faChevronRightRegular,
    large: faChevronRightLight,
  },
  'chevron-up': {
    small: faChevronUpRegular,
    regular: faChevronUpRegular,
    large: faChevronUpLight,
  },
  'checkmark': {
    small: faCheckRegular,
    regular: faCheckRegular,
    large: faCheckLight,
  },
  'copy': {
    small: faCopyRegular,
    regular: faCopyRegular,
    large: faCopyLight,
  },
  'download': {
    small: faArrowDownToLineRegular,
    regular: faArrowDownToLineRegular,
    large: faArrowDownToLineLight,
  },
  'edit': {
    small: faEditRegular,
    regular: faEditRegular,
    large: faEditLight,
  },
  'error': {
    small: faCircleExclamationRegular,
    regular: faCircleExclamationRegular,
    large: faCircleExclamationLight,
  },
  'info': {
    small: faCircleInfoRegular,
    regular: faCircleInfoRegular,
    large: faCircleInfoLight,
  },
  'link': {
    small: faLinkRegular,
    regular: faLinkRegular,
    large: faLinkLight,
  },
  'menu': {
    small: faBarsRegular,
    regular: faBarsRegular,
    large: faBarsLight,
  },
  'minus': {
    small: faMinusRegular,
    regular: faMinusRegular,
    large: faMinusLight,
  },
  'paste': {
    small: faPasteRegular,
    regular: faPasteRegular,
    large: faPasteLight,
  },
  'pause': {
    small: faPauseHeavy,
    regular: faPauseHeavy,
    large: faPauseHeavy,
  },
  'play': {
    small: faPlayHeavy,
    regular: faPlayHeavy,
    large: faPlayHeavy,
  },
  'plus': {
    small: faPlusRegular,
    regular: faPlusRegular,
    large: faPlusLight,
  },
  'search': {
    small: faMagnifyingGlassRegular,
    regular: faMagnifyingGlassRegular,
    large: faMagnifyingGlassLight,
  },
  'settings': {
    small: faGearRegular,
    regular: faGearRegular,
    large: faGearLight,
  },
  'success': {
    small: faCheckCircleRegular,
    regular: faCheckCircleRegular,
    large: faCheckCircleLight,
  },
  'user': {
    small: faUserRegular,
    regular: faUserRegular,
    large: faUserLight,
  },
  'xmark': {
    small: faXmarkRegular,
    regular: faXmarkRegular,
    large: faXmarkLight,
  },
  'xmark-circle': {
    small: faCircleXmarkRegular,
    regular: faCircleXmarkRegular,
    large: faCircleXmarkLight,
  },
  // "Decorative" icons
  'arrow-right-arrow-left': {
    small: faArrowRightArrowLeftRegular,
    regular: faArrowRightArrowLeftRegular,
    large: faArrowRightArrowLeftLight,
  },
  'bank': {
    small: faBankRegular,
    regular: faBankRegular,
    large: faBankLight,
  },
  'chart-waterfall': {
    small: faChartWaterfallRegular,
    regular: faChartWaterfallRegular,
    large: faChartWaterfallLight,
  },
  'credit-card': {
    small: faCreditCardRegular,
    regular: faCreditCardRegular,
    large: faCreditCardLight,
  },
  'gears': {
    small: faGearsRegular,
    regular: faGearsRegular,
    large: faGearsLight,
  },
  'money-bill': {
    small: faMoneyBillRegular,
    regular: faMoneyBillRegular,
    large: faMoneyBillLight,
  },
  'sparkles': {
    small: faSparklesRegular,
    regular: faSparklesRegular,
    large: faSparklesLight,
  },
  'circle-nodes': {
    small: faCircleNodesRegular,
    regular: faCircleNodesRegular,
    large: faCircleNodesLight,
  },
  'user-check': {
    small: faUserCheckRegular,
    regular: faUserCheckRegular,
    large: faUserCheckLight,
  },
  'invoice': {
    small: faFileInvoiceDollarRegular,
    regular: faFileInvoiceDollarRegular,
    large: faFileInvoiceDollarLight,
  },
  'globe': {small: faGlobeRegular, regular: faGlobeRegular, large: faGlobeLight},
  'magnifying-glass-dollar': {
    small: faMagnifyingGlassDollarRegular,
    regular: faMagnifyingGlassDollarRegular,
    large: faMagnifyingGlassDollarLight,
  },
  'stack': {
    small: faLayerGroupRegular,
    regular: faLayerGroupRegular,
    large: faLayerGroupLight,
  },
  'arrow-up-short-wide': {
    small: faArrowUpShortWideRegular,
    regular: faArrowUpShortWideRegular,
    large: faArrowUpShortWideLight,
  },
  'arrow-down-wide-short': {
    small: faArrowDownWideShortRegular,
    regular: faArrowDownWideShortRegular,
    large: faArrowDownWideShortLight,
  },
  'user-group-simple': {
    small: faUserGroupSimpleRegular,
    regular: faUserGroupSimpleRegular,
    large: faUserGroupSimpleLight,
  },
  'screwdriver-wrench': {
    small: faScrewdriverWrenchRegular,
    regular: faScrewdriverWrenchRegular,
    large: faScrewdriverWrenchLight,
  },
  'receipt': {
    small: faReceiptRegular,
    regular: faReceiptRegular,
    large: faReceiptLight,
  },
  'bell': {
    small: faBellRegular,
    regular: faBellRegular,
    large: faBellLight,
  },
  'bullseye-arrow': {
    small: faBullseyeArrowRegular,
    regular: faBullseyeArrowRegular,
    large: faBullseyeArrowLight,
  },
  'browsers': {
    small: faBrowsersRegular,
    regular: faBrowsersRegular,
    large: faBrowsersLight,
  },
  'file-user': {
    small: faFileUserRegular,
    regular: faFileUserRegular,
    large: faFileUserLight,
  },
  'table': {
    small: faTableRegular,
    regular: faTableRegular,
    large: faTableLight,
  },
  'file-zipper': {
    small: faFileZipperRegular,
    regular: faFileZipperRegular,
    large: faFileZipperLight,
  },
} as const

type FaIconSize = 'sm' | '1x' | 'xl'

const LoadingFaIcon = ({size}: {size: FaIconSize}) => {
  return (
    <div className="grid">
      <FontAwesomeIcon
        size={size}
        className="col-start-1 col-end-auto row-start-1 row-end-auto text-inherit opacity-25"
        icon={size === 'xl' ? faCircleLight : faCircleRegular}
      />
      <FontAwesomeIcon
        size={size}
        className="z-1 col-start-1 col-end-auto row-start-1 row-end-auto animate-spin text-inherit"
        icon={size === 'xl' ? faSpinnerThirdLight : faSpinnerThirdRegular}
      />
    </div>
  )
}

const HgFaIcon = ({className, iconType, size}: HgFaIconProps) => {
  // For FA icons, `sm` = .875rem, `1x` = 1rem, `xl` = 1.5rem
  const getFaIconSize = () => {
    switch (size) {
      case 'small':
        return 'sm'
      case 'large':
        return 'xl'
      default:
        return '1x'
    }
  }

  if (iconType === 'loading') {
    return <LoadingFaIcon size={getFaIconSize()} />
  }

  return (
    <FontAwesomeIcon
      size={getFaIconSize()}
      className={cn('text-inherit', className)}
      icon={SANCTIONED_FA_ICON_MAP[iconType]?.[size]}
    />
  )
}

function isHgFaIcon(iconType: HgIconType): iconType is HgFaIconType {
  return HgFaIcons.includes(iconType as HgFaIconType)
}

function isHgCustomIcon(iconType: HgIconType): iconType is HgCustomIconType {
  return HgCustomIcons.includes(iconType as HgCustomIconType)
}

const iconSize = tv({
  base: 'inline-block min-h-fit min-w-fit',
  variants: {
    size: {
      small: 'h-[0.875rem]',
      regular: 'h-[1rem]',
      large: 'h-[1.5rem]',
    },
    placeholder: {
      true: 'fill-none text-inherit',
    },
  },
})

const HgIcon = ({className, iconType, size}: HgIconProps) => {
  if (isHgFaIcon(iconType)) {
    return (
      <HgFaIcon
        className={cn(className, iconType === 'play' && 'relative -right-1')}
        iconType={iconType}
        size={size}
      />
    )
  }

  if (isHgCustomIcon(iconType)) {
    switch (iconType) {
      case 'placeholder':
        return (
          <Placeholder
            className={iconSize({size, placeholder: true, class: className})}
          />
        )
      default:
        return null
    }
  }

  return unreachableCase(iconType)
}

export default HgIcon
